import React from "react";

const Icons = (props) => {
	switch (props.geticon) {
		case "dropdown-list":
			return (
				<>
					{/* <svg height="30" viewBox="0 0 50 50" width="30" xmlns="http://www.w3.org/2000/svg">
					<path d="M14 20l10 10 10-10z" />
					<path d="M0 0h48v48h-48z" fill="none" />
				</svg> */}
					<svg className="dcaret" viewBox="2 2 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
						<g id="Arrow / Caret_Down_SM">
							<path id="Vector" d="M15 11L12 14L9 11" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
						</g>
					</svg>
				</>
			);
		case "pa-icon": //gstreport
			return (
				<svg className="pa-icon" width="35px" height="35px" viewBox="-6 -3 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M7 8H17M7 12H17M9 16H15M4 12V20H20V4H4V7" stroke="#000000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
				</svg>
			);
		case "child":
			return <span>i</span>;
		case "home":
			return (
				<svg width="35px" height="40px" viewBox="0 -2 24.00 24.00" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff">
					<path d="M15 14L12 14M12 14L9 14M12 14L12 11M12 14L12 17" stroke="#ffffff" strokeWidth="1.6320000000000001" strokeLinecap="round"></path>{" "}
					<path
						d="M22 12.2039V13.725C22 17.6258 22 19.5763 20.8284 20.7881C19.6569 22 17.7712 22 14 22H10C6.22876 22 4.34315 22 3.17157 20.7881C2 19.5763 2 17.6258 2 13.725V12.2039C2 9.91549 2 8.77128 2.5192 7.82274C3.0384 6.87421 3.98695 6.28551 5.88403 5.10813L7.88403 3.86687C9.88939 2.62229 10.8921 2 12 2C13.1079 2 14.1106 2.62229 16.116 3.86687L18.116 5.10812C20.0131 6.28551 20.9616 6.87421 21.4808 7.82274"
						stroke="#ffffff"
						strokeWidth="2"
						strokeLinecap="round"
					></path>
				</svg>
			);
		case "heline":
			return (
				<svg className="heline" height="25px" width="30px" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 30 30">
					<rect x="14" width="2" height="30" />
				</svg>
			);
		case "helinelast":
			return (
				<svg height="30px" width="30px" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 30 30">
					<polygon points="23,16 23,18 14,18 14,0 16,0 16,16 " />
				</svg>
			);
		case "single":
			return (
				<svg height="30" viewBox="-250 -250 1000 1000" width="30">
					{/* <g>
						<path d="M256,48C141.1,48,48,141.1,48,256s93.1,208,208,208c114.9,0,208-93.1,208-208S370.9,48,256,48z M256,446.7    c-105.1,0-190.7-85.5-190.7-190.7c0-105.1,85.5-190.7,190.7-190.7c105.1,0,190.7,85.5,190.7,190.7    C446.7,361.1,361.1,446.7,256,446.7z" />
					</g> */}
					<g>
						<path d="M256,96c-88.4,0-160,71.6-160,160c0,88.4,71.6,160,160,160c88.4,0,160-71.6,160-160C416,167.6,344.4,96,256,96z" />
					</g>
				</svg>
			);
		case "up-menu":
			return (
				<svg width="40px" height="40px" viewBox="-3 -3 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M7 3V21M7 3L11 7M7 3L3 7M14 3H15M14 9H17M14 15H19M14 21H21" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
				</svg>
			);
		case "left-menu":
			return (
				<svg width="35px" height="35px" viewBox="0 -2 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M4 6H20M4 12H20M4 18H20" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
				</svg>
			);
		case "left-menu1":
			return (
				<div className="menu-btn" onClick={() => props.abs()}>
					<div className="menu-btn__burger"></div>
				</div>
			);
		case "cross":
			return (
				<div className="menu-btn open" onClick={() => props.passunabs5()}>
					<div className="menu-btn__burger"></div>
				</div>
			);
		case "close":
			return (
				<svg xmlns="http://www.w3.org/2000/svg" width="50px" height="50px" viewBox="0 5 32 32" id="close">
					<path d="M10.05 23.95a1 1 0 0 0 1.414 0L17 18.414l5.536 5.536a1 1 0 0 0 1.414-1.414L18.414 17l5.536-5.536a1 1 0 0 0-1.414-1.414L17 15.586l-5.536-5.536a1 1 0 0 0-1.414 1.414L15.586 17l-5.536 5.536a1 1 0 0 0 0 1.414z"></path>
				</svg>
			);
		case "search":
			return (
				<svg width="30px" height="35px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M16.6725 16.6412L21 21M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
				</svg>
			);
		case "ddlogo":
			return (
				<svg width="40px" height="45px" viewBox="0 0 320 340" fill="#ffffff" stroke="#ffffff">
					<style type="text/css"></style>
					<g>
						<g>
							<path
								className="st0"
								d="M45.43,35.87c5.4,0.07,10.8,0.14,16.24,0.24c-0.07,5.09-0.14,10.21-0.21,15.3
			c-5.23,0.1-10.45,0.21-15.64,0.31C45.68,46.43,45.54,41.17,45.43,35.87z"
							/>
							<path
								className="st0"
								d="M107.1,44.76c5.33,0.03,10.7,0.07,16.06,0.1c-0.14,5.19-0.24,10.42-0.38,15.61
			c-5.33-0.24-10.63-0.45-15.96-0.7C106.93,54.76,107,49.74,107.1,44.76z"
							/>
							<path
								className="st0"
								d="M67.07,59.88c10.03,0,20.07,0,30.1,0c0,9.76,0,19.51,0,29.27c-10.03,0-20.07,0-30.1-0.03
			C67.07,79.39,67.04,69.64,67.07,59.88z"
							/>
							<path
								className="st0"
								d="M110.1,67.55c8.61,0,17.21,0,25.82,0c0,8.36,0,16.69,0,25.05c-8.61,0.03-17.21,0.03-25.82,0.03
			C110.1,84.27,110.1,75.91,110.1,67.55z"
							/>
							<path
								className="st0"
								d="M50.66,100.51c8.61,0,17.18,0,25.75-0.03c0.03,8.4,0.07,16.76,0.07,25.16c-8.61,0-17.25-0.03-25.85-0.07
			C50.66,117.23,50.66,108.87,50.66,100.51z"
							/>
							<path
								className="st0"
								d="M85.29,150.43c0-16.65-0.07-33.34,0.14-50c17.14,0.1,34.32,0.07,51.5,0.1c0.03,16.62,0.03,33.27,0,49.89
			C119.72,150.47,102.5,150.47,85.29,150.43z"
							/>
							<path
								className="st0"
								d="M60.49,141.2c5.33-0.03,10.66-0.03,16.03-0.03c-0.03,5.19-0.07,10.42-0.07,15.61
			c-5.33-0.03-10.63-0.03-15.92-0.07C60.49,151.55,60.49,146.36,60.49,141.2z"
							/>
						</g>
						<path
							className="st0"
							d="M144.98,100.67c84.29-4.32,135.59,25.6,135.59,98.28c0,82.04-58.36,106.67-135.59,105.1
		c-19.94,0.1-39.87-0.03-59.81,0.07c0.1-48.87,0.19-97.53,0.29-146.4l59.52,0.58v87.68c4.74,0,9.49,0,14.23,0h16.43
		c17.09,0,33.31-9.09,40.95-24.38c3.17-6.34,4.88-13.44,4.74-20.77c-0.06-3.23-0.47-6.4-1.21-9.47
		c-4.74-19.81-23.3-33.21-43.66-33.21l-31.49,0.15C144.98,146.4,144.98,116.57,144.98,100.67z"
						/>
						<path
							className="st0"
							d="M158.8,172.69v59.45c5.65,0.1,11.3,0.21,16.95,0.31c10.93,0.2,21.56-5.06,27.06-14.5
		c2.56-4.39,4.04-9.45,4.12-14.77c0.09-6.32-1.8-12.31-5.14-17.32c-5.58-8.33-15.32-12.92-25.35-13.01
		C170.56,172.8,164.68,172.74,158.8,172.69z"
						/>
					</g>
				</svg>
			);
		case "listme":
			return (
				<>
					{/* <svg className="pa-icon" width="35px" height="35px" viewBox="0 0 100 40" strokeWidth="5" stroke="#003049" fill="none" xmlns="http://www.w3.org/2000/svg">
						<polygon points="52.18 16.06 35.84 28.22 19.49 16.06 35.84 3.9 52.18 16.06" />
						<polyline points="46.55 20.25 52.18 24.43 35.84 36.59 19.49 24.43 25.12 20.25" />
					</svg> */}
					<svg className="pa-icon" width="35px" height="35px" xmlns="http://www.w3.org/2000/svg" viewBox="0 2 60 35">
						{/* <polygon class="cls-1" points="52.18 16.06 35.84 28.22 19.49 16.06 35.84 3.9 52.18 16.06" /> */}
						{/* <polyline class="cls-1" points="46.55 20.25 52.18 24.43 35.84 36.59 19.49 24.43 25.12 20.25" /> */}
						{/* <path class="cls-1" d="M33.48,14.67,18.88,25.34a2.34,2.34,0,0,1-2.76,0L1.52,14.67a2.26,2.26,0,0,1,0-3.65L16.12.34a2.34,2.34,0,0,1,2.76,0L33.48,11A2.26,2.26,0,0,1,33.48,14.67Z" transform="translate(18.33 2.75)" /> */}
						{/* <path class="cls-1" d="M31.93,18.93l1.7,1.51a2.1,2.1,0,0,1,0,3.42L19.43,34.25a3.27,3.27,0,0,1-3.86,0L1.39,23.88a2.13,2.13,0,0,1,0-3.46l1.84-1.1" transform="translate(18.33 2.75)" /> */}
						<path className="cls-1" d="M33.48,14.67,18.88,25.34a2.34,2.34,0,0,1-2.76,0L1.52,14.67a2.26,2.26,0,0,1,0-3.65L16.12.34a2.34,2.34,0,0,1,2.76,0L33.48,11A2.26,2.26,0,0,1,33.48,14.67Z" transform="translate(18.33 2.75)" />
						<path className="cls-1" d="M33.12,20l.51.46a2.1,2.1,0,0,1,0,3.42L19.43,34.25a3.27,3.27,0,0,1-3.86,0L1.39,23.88a2.13,2.13,0,0,1,0-3.46l.91-.73" transform="translate(18.33 2.75)" />
					</svg>
				</>
			);
		case "invReport":
			return (
				<>
					<svg className="pa-icon" width="35px" height="35px" xmlns="http://www.w3.org/2000/svg" viewBox="-15 -5 50 35">
						<path className="cls-1" d="M4.52,11.88V7.08A3.11,3.11,0,0,1,7.63,4h4.46" transform="translate(-1.6 -3.97)" />
						<path className="cls-1" d="M30.54,11.88V7.08A3.11,3.11,0,0,0,27.43,4H23" transform="translate(-1.6 -3.97)" />
						<path className="cls-1" d="M4.52,23.53v4.79a3.12,3.12,0,0,0,3.11,3.12h4.46" transform="translate(-1.6 -3.97)" />
						<path className="cls-1" d="M30.54,23.53v4.79a3.12,3.12,0,0,1-3.11,3.12H23" transform="translate(-1.6 -3.97)" />
						{/* <line className="cls-1" y1="19.56" x2="31.8" y2="19.56" /> */}
						<line className="cls-1" x1="5.94" y1="12.83" x2="25.85" y2="12.83" />
					</svg>
				</>
			);
		case "inv":
			return <img src="/icons/inv.png" alt="" />;
		case "transcition":
			return (
				<>
					<svg className="pa-icon1" width="35px" height="35px" xmlns="http://www.w3.org/2000/svg" viewBox="-6 0 24 16">
						<path
							className="cls-1"
							d="M5 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5M3.854 2.146a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708L2 3.293l1.146-1.147a.5.5 0 0 1 .708 0m0 4a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708L2 7.293l1.146-1.147a.5.5 0 0 1 .708 0m0 4a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 0 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0"
						/>
					</svg>
				</>
			);
		case "acc-repo":
			return (
				<>
					<svg className="pa-icon1" width="35px" height="35px" xmlns="http://www.w3.org/2000/svg" viewBox="-9 0 28 16">
						<path className="cls-1" d="M13 6.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 .5-.5m0 3a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 .5-.5m-.5 2.5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1z" />
						<path className="cls-1" d="M14 0a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zM2 1a1 1 0 0 0-1 1v1h14V2a1 1 0 0 0-1-1zM1 4v10a1 1 0 0 0 1 1h2V4zm4 0v11h9a1 1 0 0 0 1-1V4z" />
					</svg>
				</>
			);
		case "multico-repo":
			return (
				<>
					<svg className="pa-icon1" width="35px" height="35px" xmlns="http://www.w3.org/2000/svg" viewBox="-10 0 28 16">
						<path className="cls-1" d="M6 1H1v14h5zm9 0h-5v5h5zm0 9v5h-5v-5zM0 1a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1zm9 0a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1zm1 8a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1z" />
					</svg>
				</>
			);
		case "final":
			return (
				<>
					<svg className="pa-icon1" width="35px" height="35px" xmlns="http://www.w3.org/2000/svg" viewBox="-9 0 28 16">
						<path className="cls-1" d="M0 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm8.5-1v12H14a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm-1 0H2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h5.5z" />
					</svg>
				</>
			);
		// case "transcition":
		// 	return (
		// 		<>
		// 			<svg className="pa-icon1" width="35px" height="35px" xmlns="http://www.w3.org/2000/svg" viewBox="-6 0 24 16">
		// 				<path
		// 					className="cls-1"
		// 					d="M5 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5M3.854 2.146a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708L2 3.293l1.146-1.147a.5.5 0 0 1 .708 0m0 4a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708L2 7.293l1.146-1.147a.5.5 0 0 1 .708 0m0 4a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 0 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0"
		// 				/>
		// 			</svg>
		// 		</>
		// 	);
		case "gen-acc-rep":
			return (
				<>
					<svg className="pa-icon1" width="35px" height="35px" xmlns="http://www.w3.org/2000/svg" viewBox="-8 0 24 16">
						<path className="cls-1" d="M5 10.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5" />
						<path className="cls-1" d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2" />
						<path className="cls-1" d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1z" />
					</svg>
				</>
			);
		case "co-master":
			return (
				<>
					<svg className="pa-icon1" width="35px" height="35px" xmlns="http://www.w3.org/2000/svg" viewBox="-8 0 24 16">
						<path className="cls-1" d="M12 1a1 1 0 0 1 1 1v10.755S12 11 8 11s-5 1.755-5 1.755V2a1 1 0 0 1 1-1zM4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" />
						<path className="cls-1" d="M8 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
					</svg>
				</>
			);
		case "exit":
			return (
				<>
					<svg className="pa-icon1" width="35px" height="35px" xmlns="http://www.w3.org/2000/svg" viewBox="-8 0 24 16">
						<path className="cls-1" d="M8.538 1.02a.5.5 0 1 0-.076.998 6 6 0 1 1-6.445 6.444.5.5 0 0 0-.997.076A7 7 0 1 0 8.538 1.02" />
						<path className="cls-1" d="M7.096 7.828a.5.5 0 0 0 .707-.707L2.707 2.025h2.768a.5.5 0 1 0 0-1H1.5a.5.5 0 0 0-.5.5V5.5a.5.5 0 0 0 1 0V2.732z" />
					</svg>
				</>
			);
		default:
			return <p>Oops</p>;
	}
};

export default Icons;
